import { Text } from '@pairy/pds-react';

interface Props {
  clientName: string;
  linkName: string;
}

const DeletionNotice = ({ clientName, linkName }: Props) => {
  return (
    <>
      <Text as="p" variant="lg-regular">
        삭제 시, <b>{clientName}</b>에게 보낸 <b>{linkName}</b> 링크가 동작하지
        않습니다.
        <br />
        그래도 삭제할까요?
      </Text>
      <Text as="p" variant="sm-semibold" color="zinc_400" marginTop={8}>
        공유 링크는 삭제 후 복구할 수 없습니다.
      </Text>
    </>
  );
};

export default DeletionNotice;
